const getAllTax = `getAllTax{percent, code, id}`;

export default getAllTax;
